module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/40919cee701a9297cd1e90595c089544.png";